const INITIAL_STATE = {
  selected: null
}

const reducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

  case 'CHOOSE':
    return {
      ...state,
      selected: action.index
    }

  case 'CLEAR':
    return {
      ...state,
      selected: null
    }

  default:
    return state
  }

}

export default reducer
